export default __webpack_public_path__ + "static/media/aKozegeszsegugyMeggyogyitasa.bd6682c9.png";